interface Props {
  /** コンテナ相対のX座標（px） */
  x: number;
  /** コンテナ相対のY座標（px） */
  y: number;
  /** 系列ラベル（グループ名） */
  label: string;
  /** 系列値 */
  value: number;
  /** 単位（'名' | '件'） */
  unit: string;
}

/**
 * グループモード時のセグメントホバー用フローティングポップ。
 * - SVG 上のホバーイベントを阻害しないよう pointer-events: none
 * - スクリーンリーダーへの通知に role="tooltip" + aria-live="polite"
 */
export default function FunnelChartHoverPopup({ x, y, label, value, unit }: Props) {
  return (
    <div
      role="tooltip"
      aria-live="polite"
      style={{
        position: 'absolute',
        left: x + 12,
        top: y - 36,
        pointerEvents: 'none',
        background: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: 4,
        boxShadow: '0px 0px 6px 0px rgba(0,0,0,0.2)',
        fontSize: 12,
        padding: '6px 10px',
        color: '#3e3f42',
        whiteSpace: 'nowrap',
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
      }}
    >
      <span>{label}</span>
      <span style={{ fontWeight: 700 }}>
        {value.toLocaleString()}
        {unit}
      </span>
    </div>
  );
}
